import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../auth";
import { QueryKeys } from "../QueryKeys";
import { useApi } from "../useApi";

export const useFetchTermsAndConditionsStatus = (isDeepLinkHandled: boolean) => {
  const { api } = useApi();
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: [QueryKeys.fetchTermsAndConditionsStatus],
    queryFn: () => api.patient.getTermsAcceptedStatus(),
    enabled: isDeepLinkHandled && isAuthenticated,
  });
};
